import React, { useEffect, useState } from "react";
import {
  Grid,
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Radio,
  RadioGroup,
  FormLabel,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import MDEditor from "@uiw/react-md-editor";
import Button from "components/CustomButtons/Button.js";
import NotificationContext from "views/Components/Context.js";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { stepperStyles, QontoConnector } from "views/Styles/stepperStyles";
import { COMPANY_MODELS, getCompanyIcon } from "views/Components/Constants.js";
import { quCreateColor } from "assets/jss/material-dashboard-pro-react";
import { validateKeyAPI, fetchQuAPIVaultAPI } from "views/APIs/APIUtility";

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stepperStyles(theme),
  customCheckbox: {
    color: quCreateColor,
    "&.Mui-checked": { color: quCreateColor },
  },
}));

export default function SubmitLabModal({
  reviewDialog,
  handleReviewDialogClose,
  lab,
  specifications,
  modelDetails,
  setModelDetails,
  submitHandler,
  license,
  setLicense,
  framework,
  setFramework,
}) {
  const classes = useStyles();
  const { showNotification } = React.useContext(NotificationContext);

  // Add new "Artifacts" step between Review and Submit
  const dialogStages = ["Review Lab", "Submit"];
  const stepperDisplayStages = ["Review Lab"];

  const [error, setError] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [currentDialog, setCurrentDialog] = useState(dialogStages[0]);
  const [saveKey, setSaveKey] = useState(false);
  const [loading, setLoading] = useState({ loading: false, message: "" });
  const [artifactOption, setArtifactOption] = useState("jupyter");

  const [companies, setCompanies] = useState(Object.keys(COMPANY_MODELS));
  const [allKeys, setAllKeys] = useState([]);
  const modelOptions = modelDetails.company
    ? COMPANY_MODELS[modelDetails.company]
    : [];

  // useEffect(() => {
  //   async function fetchKeys() {
  //     try {
  //       const fetchedKeys = await fetchQuAPIVaultAPI();
  //       setAllKeys(fetchedKeys);
  //     } catch (err) {
  //       console.error("Error in fetchKeys:", err);
  //       showNotification("Error fetching keys", "danger");
  //     }
  //   }
  //   fetchKeys();
  // }, []);

  const handleNavigation = (e, newValue) => {
    if (!(tabValue === 0 && newValue === 0)) {
      setTabValue(newValue);
      setModelDetails({ company: "", model: "", apiKey: "", name: "" });
      setError("");
    }
  };

  const handleKeySelection = (keyName) => {
    const selected = allKeys.find((k) => k.name === keyName);
    if (selected) {
      setModelDetails({
        company: selected.company,
        model: selected.model,
        apiKey: selected.key,
        name: selected.name,
        description: selected.description,
      });
    }
  };

  const renderDialogContent = () => {
    switch (currentDialog) {
      case "Review Lab":
        return (
          <Box data-color-mode="light" mt={1}>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold" }}
              gutterBottom
            >
              Please review the specifications below:
            </Typography>
            <Box mt={2}>
              {lab && (
                <MDEditor
                  preview="preview"
                  disabled
                  value={specifications}
                  hideToolbar
                  height={500}
                />
              )}
            </Box>
          </Box>
        );

      case "Submit":
        return (
          <Box display="flex" alignItems="center">
            <CircularProgress size={20} />
            <Box ml={1}>
              <Typography>{loading.message}</Typography>
            </Box>
          </Box>
        );

      default:
        return null;
    }
  };

  const handleStepReview = () => {
    setActiveStep(1);
    setCurrentDialog(dialogStages[1]);
  };

  const handleSubmit = async () => {
    setLoading({ loading: true, message: "Submitting Lab for Generation..." });
    setCurrentDialog(dialogStages[1]);
    const saveAPIKEY = tabValue === 1 && saveKey;
    await submitHandler();
    handleReviewDialogClose();
    setLoading({ loading: false, message: "" });
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
      setCurrentDialog(dialogStages[activeStep - 1]);
    }
  };

  return (
    <Dialog
      open={reviewDialog}
      onClose={handleReviewDialogClose}
      aria-labelledby="form-dialog-title"
      maxWidth="lg"
      fullWidth
    >
      {/* <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<QontoConnector />}
        className={classes.stepperRoot}
      >
        {stepperDisplayStages.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconProps={{
                classes: {
                  root: classes.stepIcon,
                  active: classes.activeStepIcon,
                  completed: classes.completedStepIcon
                }
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper> */}

      <Divider />
      <DialogContent style={{ marginTop: 16 }}>
        {renderDialogContent()}
      </DialogContent>

      {activeStep === 0 && (
        <DialogActions style={{ justifyContent: "space-between", padding: "16px 24px", display: "flex", alignItems: "center" }}>
          <Button onClick={handleReviewDialogClose} color="quSandBoxColor">
            Continue Editing
          </Button>
          
          <FormControl component="fieldset">
            <FormLabel component="legend" style={{ fontSize: "0.875rem", marginBottom: "4px" }}>
              Choose Framework
            </FormLabel>
            <Box display="flex" flexDirection="row" alignItems="center">
              <FormControlLabel
                value="robust"
                control={
                  <Radio
                    className={classes.customCheckbox}
                    checked={framework === "robust"}
                    onChange={(e) => setFramework(e.target.value)}
                  />
                }
                label="Robust Test-Oriented"
                style={{ marginRight: "0" }}
              />
              <Tooltip title="Slower generation, but tested and works with any model" arrow placement="top">
                <IconButton size="small" style={{ padding: "4px", marginRight: "16px" }}>
                  <HelpOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <FormControlLabel
                value="oneshot"
                control={
                  <Radio
                    className={classes.customCheckbox}
                    checked={framework === "oneshot"}
                    onChange={(e) => setFramework(e.target.value)}
                  />
                }
                label="One-Shot"
                style={{ marginRight: "0" }}
              />
              <Tooltip title="Faster generation, but untested and requires your API key to support structured completion and code execution for your models (e.g., gemini-pro-3)" arrow placement="top">
                <IconButton size="small" style={{ padding: "4px" }}>
                  <HelpOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </FormControl>

          <FormControl style={{ minWidth: "200px" }}>
            <InputLabel id="license-label">Choose License</InputLabel>
            <Select
              labelId="license-label"
              value={license}
              onChange={(e) => setLicense(e.target.value)}
              label="License"
            >
              <MenuItem value="QuantUniversity License">QuantUniversity License</MenuItem>
              <MenuItem value="MIT License">MIT License</MenuItem>
            </Select>
          </FormControl>

          <Button
            onClick={() => {
              switch (currentDialog) {
                case "Review Lab":
                  handleSubmit();
                  break;
                default:
                  break;
              }
            }}
            color="quCreateColor"
          >
            {currentDialog === "Review Lab" ? "Submit for Generation" : "Next"}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
